export default "__VITE_ASSET__402ea1d1__"